import React from 'react';
import {
  IconButton, Tooltip, Button, Fab,
} from '@mui/material';

import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import { Settings, People, Done } from '@mui/icons-material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import RefreshIcon from '@mui/icons-material/Refresh';

class CustomToolbar extends React.Component {
  get action() {
    const { type, onClick } = this.props;
    switch (type) {
      case 'Add':
        return (
          <Tooltip title={type}>
            <Fab color="secondary" onClick={onClick}>
              <AddIcon />
            </Fab>
          </Tooltip>
        );
      case 'Edit':
        return (
          <Tooltip title={type}>
            <IconButton onClick={onClick}>
              <EditIcon />
            </IconButton>
          </Tooltip>
        );
      case 'Wrench':
        return (
          <Tooltip title="Change Settings">
            <IconButton onClick={onClick}>
              <Settings />
            </IconButton>
          </Tooltip>
        );
      case 'People':
        return (
          <Tooltip title="Reassign">
            <IconButton onClick={onClick}>
              <People />
            </IconButton>
          </Tooltip>
        );
      case 'Upload':
        return (
          <Tooltip title={type}>
            <IconButton onClick={onClick}>
              <CloudUploadIcon />
            </IconButton>
          </Tooltip>
        );
      case 'Done':
        return (
          <Tooltip title="Close">
            <IconButton onClick={onClick}>
              <Done />
            </IconButton>
          </Tooltip>
        );
      case 'Save':
        return (
          <Button
            onClick={onClick}
            color="primary"
          >
            Save
          </Button>
        );
      case 'Cancel':
        return (
          <Button
            color="secondary"
            onClick={onClick}
          >
            {type}
          </Button>
        );
      case 'Delete':
        return (
          <Tooltip title={type}>
            <IconButton onClick={onClick}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        );
      case 'Download':
        return (
          <Tooltip title={type}>
            <IconButton onClick={onClick}>
              <CloudDownloadIcon />
            </IconButton>
          </Tooltip>
        );
      case 'Refresh':
        return (
          <Tooltip title={type}>
            <IconButton onClick={onClick}>
              <RefreshIcon />
            </IconButton>
          </Tooltip>
        );
      default:
        return '';
    }
  }

  render() {
    return this.action;
  }
}

export default CustomToolbar;
